// extracted by mini-css-extract-plugin
export var productCard = "style-module--productCard--b66d6";
export var productImage = "style-module--productImage--22a74";
export var quickview = "style-module--quickview--4bf38";
export var recProductButton = "style-module--recProductButton--bd8d8";
export var yotpoDisplayWrapper = "style-module--yotpo-display-wrapper--5e984";